import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { useQuery } from "react-query";
import noData from "../../../../assets/errors/noData.png";
import { useLocation, useParams } from "react-router-dom";
// PrimeReact
import { Button } from "primereact/button";
import { Skeleton } from "primereact/skeleton";
import Select from "../../../../components/input/Select";
// Serviços
import { getParcelDescription } from "../../../../services/GlobalRoles/getParcelDescription";
import { getCostCenter } from "../../../../services/CostCenter/getCostCenter";
import { postCostCenterAssociations } from "../../../../services/Financial/AccountToPay/postCostCenterAssociations";
import { getCostAssociationsById } from "../../../../services/Financial/AccountToPay/getCostAssociationsById";
//contexto

const CenterCostLink = () => {
  const { id } = useParams();
  const [cost_center, setCostCenter] = useState(null);
  const form = useForm();
  const {
    register,
    handleSubmit,
    control,
    setValue,
    getValues,
    formState: { errors },
  } = form;
  // Buscar descrições das parcelas
  const {
    data: parcelsDescription,
    isLoading: isLoadingDesc,
    error,
  } = useQuery({
    queryKey: ["parcelDescription"],
    queryFn: () => getParcelDescription(),
  });
  // Buscar Centros de Custo
  const { data, isLoading } = useQuery({
    queryKey: ["cost-center"],
    queryFn: () => getCostCenter(),
  });

  // Função para processar e enviar os dados
  const onSubmit = async () => {
    const formData = getValues(); // Obtém todos os valores do formulário
  
    // Criando payload no formato desejado
    const payload = {
      enterprise_id: id, 
      datas: parcelsDescription.map((parcel, index) => ({
        installment_description_id: parcel.id, // ID da descrição da parcela
        cost_center_id: formData[`cost_center_id_${index}`], // ID do centro de custo selecionado
      })),
    };
  
    // Validação: Verificar se todos os campos foram preenchidos
    const hasEmptyFields = payload.datas.some((item) => !item.cost_center_id);
    if (hasEmptyFields) {
      toast.error("Todos os Centros de Custo precisam ser selecionados antes de salvar.");
      return;
    }
  
    // Exibir toast de carregamento
    const notification = toast.loading("Por favor, aguarde...");
  
    try {
      const response = await postCostCenterAssociations(payload);
  
      // Atualiza o toast de carregamento com a resposta de sucesso
      toast.update(notification, {
        render: response?.message || "Associações salvas com sucesso!",
        autoClose: 5000,
        type: "success",
        isLoading: false,
      });
  
    } catch (err) {
      console.error("Erro ao salvar associações:", err);
  
      // Atualiza o toast de carregamento para erro
      toast.update(notification, {
        render: "Erro ao salvar associações.",
        autoClose: 5000,
        type: "error",
        isLoading: false,
      });
    }
  };
  

  //recebendo o centro de custo
  useEffect(() => {
    if (data) {
      //ordenando o centro de custo
      data.sort((a, b) => {
        const refA = a.ref.split(".").map(Number);
        const refB = b.ref.split(".").map(Number);

        // Comparar cada parte separadamente
        for (let i = 0; i < Math.max(refA.length, refB.length); i++) {
          const numA = refA[i] || 0; // Se não houver valor, assume 0
          const numB = refB[i] || 0;

          if (numA !== numB) {
            return numA - numB;
          }
        }

        return 0;
      });
      const refactorData = data.map((item) => ({
        value: item.id,
        label: `${item.ref} - ${item.desc}`,
      }));
      setCostCenter(refactorData);
    }
  }, [data]);
  // Buscar dados já salvos e preencher os selects
  useEffect(() => {
    const fetchCostAssociations = async () => {
      if (!id) return;

      try {
        const response = await getCostAssociationsById(id);

        const savedValues = response;

        // Preencher os selects com os valores salvos
        savedValues.forEach((item, index) => {
          if (item.cost_center_id) {
            setValue(`cost_center_id_${index}`, item.cost_center_id);
          }
        });
      } catch (err) {
        console.error("Erro ao buscar os dados:", err);
        toast.error("Erro ao buscar os dados.");
      }
    };

    fetchCostAssociations();
  }, [id, setValue]);

  return (
    <div>
      <h3>Vínculo do Custo </h3>

      {isLoadingDesc ? (
        <Skeleton width="100%" height="2rem" className="my-2" />
      ) : error ? (
        <div className="alert alert-danger">
          Erro ao carregar as descrições.
        </div>
      ) : parcelsDescription && parcelsDescription.length > 0 ? (
        <form onSubmit={handleSubmit(onSubmit)}>
          <table className="table table-striped">
            <thead>
              <tr>
                <th className="w-50">
                  Descrições de Parcelas Cadastradas nas Configurações
                </th>
                <th className="w-50">
                  Código Referência / Descrição do Centro de Custo
                </th>
              </tr>
            </thead>
            <tbody>
              {parcelsDescription.map((parcel, index) => (
                <tr key={index}>
                  <td>{parcel.description}</td>

                  <td>
                    <Select
                      name={`cost_center_id_${index}`}
                      label="Centro de Custo"
                      control={control}
                      errors={errors}
                      options={cost_center}
                      disabled={isLoading}
                      register={register}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <div className="row d-flex justify-content-end">
            <Button
              rounded
              type="submit"
              aria-label="Salvar"
              className="rounded-3 py-2.5 col-md-3 mt-3 d-flex align-items-center justify-content-center"
            >
              <i className="fa fa-save me-2"></i>
              Salvar
            </Button>
          </div>
        </form>
      ) : (
        <div className="text-center">
          <img src={noData} alt="Sem dados" width="200" />
          <p className="mt-2">Nenhuma descrição encontrada.</p>
        </div>
      )}
    </div>
  );
};

export default CenterCostLink;
